import { clone } from './helpers';
import type { GameState, PlayerId, PlayerView } from './types';

/** The state as one player is allowed to see it. */
export function viewFor(state: GameState, viewer: PlayerId): PlayerView {
  const current = state.players[state.currentPlayerIndex];
  return {
    viewer,
    config: state.config,
    round: state.round,
    phase: state.phase,
    currentPlayerId: current ? current.id : null,
    players: state.players.map((p) => ({
      id: p.id,
      name: p.name,
      color: p.color,
      kind: p.kind,
      eliminated: p.eliminated,
      hand: p.id === viewer ? [...p.hand] : null,
      handSize: p.hand.length,
    })),
    territories: clone(state.territories),
    deckSize: state.deck.length,
    discard: [...state.discard],
    reinforcementsPending: state.reinforcementsPending,
    drawsPending: state.drawsPending,
    pendingOccupy: state.pendingOccupy,
    fortified: state.fortified,
    modifiers: clone(state.modifiers),
    outcome: state.outcome,
  };
}
